module.exports = __webpack_public_path__ + "static/media/6.43d077a6.jpg";